import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import ViewList from '@mui/icons-material/ViewList';
import { Card, Typography, IconButton } from '@totalsoft/rocket-ui';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import { getErrors } from '@totalsoft/pure-validations-react';
import DocumentTypePropertyStatesListItemComponent from './DocumentTypePropertyStatesListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE } from 'constants/rightsCodes';

const DocumentTypePropertyStatesListComponent = ({
  states,
  allowedStates,
  onSave,
  onAdd,
  onPropertyChanged,
  onDelete,
  validation,
  saveDisabled
}) => {
  const [t] = useTranslation();
  const canWrite = usePermission(ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE);

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('DocumentTypes.DocumentTypeProperty.States.Title')}
      footer={<Typography color='error'>{validation |> getErrors}</Typography>}
      actions={
        <>
          <IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.Add')} onClick={onAdd} disabled={!canWrite} />
          <IconButton
            type='save'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.Save')}
            onClick={onSave}
            disabled={(validation |> getErrors) !== '' || saveDisabled || !states.changed || !canWrite}
          />
        </>
      }
    >
      <>
        <Prompt
          when={states.changed && !states.saving}
          message={t('DocumentTypes.DocumentTypeProperty.EditDocumentTypeProperty.LeavingWithoutSavingDocumentTypeProperty')}
        />
        <CardNoResultsWrapper content={states?.values}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('DocumentTypes.DocumentTypeProperty.States.StateName')}</TableCell>
                <TableCell>{t('DocumentTypes.DocumentTypeProperty.States.AllowEdit')}</TableCell>
                <TableCell>{t('DocumentTypes.DocumentTypeProperty.Actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {states?.values.map((item, idx) => {
                return (
                  <DocumentTypePropertyStatesListItemComponent
                    state={item}
                    index={idx}
                    key={idx}
                    allowedStates={allowedStates}
                    onPropertyChanged={onPropertyChanged}
                    validation={validation}
                    onDelete={onDelete}
                  />
                );
              })}
            </TableBody>
          </Table>
        </CardNoResultsWrapper>
      </>
    </Card>
  );
};

DocumentTypePropertyStatesListComponent.propTypes = {
  states: PropTypes.object.isRequired,
  allowedStates: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  saveDisabled: PropTypes.bool.isRequired
};

export default DocumentTypePropertyStatesListComponent;
